var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_316_458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4891 3.5114C15.8069 -1.16981 8.19236 -1.16981 3.51016 3.5114C-1.17001 8.19261 -1.17001 15.8091 3.51016 20.4904C5.85126 22.8305 8.92569 24 12.0002 24C15.0746 24 18.148 22.8304 20.4891 20.4904C25.1703 15.8092 25.1703 8.19261 20.4891 3.5114ZM16.9514 15.538C17.3426 15.9292 17.3426 16.5615 16.9514 16.9527C16.8587 17.0457 16.7484 17.1195 16.627 17.1698C16.5056 17.2201 16.3755 17.246 16.2441 17.2458C16.1127 17.2459 15.9826 17.2201 15.8612 17.1698C15.7398 17.1195 15.6295 17.0457 15.5368 16.9527L12.0001 13.415L8.46445 16.9516C8.27683 17.1392 8.02242 17.2447 7.75711 17.2448C7.62571 17.2449 7.49558 17.2191 7.3742 17.1688C7.25281 17.1185 7.14256 17.0447 7.04976 16.9516C6.65859 16.5605 6.65859 15.9272 7.04976 15.537L10.5854 12.0004L7.04878 8.46372C6.65761 8.07255 6.65761 7.43925 7.04878 7.04907C7.43896 6.6579 8.07226 6.6579 8.46342 7.04907L12.0001 10.5857L15.5367 7.04907C15.9279 6.6579 16.5602 6.6579 16.9514 7.04907C17.3425 7.43925 17.3425 8.07255 16.9514 8.46372L13.4147 12.0004L16.9514 15.538Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_316_458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.e66d10920163c1ae4c4c6fc72b338b4f.svg";
export { ForwardRef as ReactComponent };